<template>
  <div class="section_pencarian_barang">
    <div class="row">
      <div class="col-md-3 col-xs-12">
        <div class="card">
          <div class="card-body">
            <h3 class="text-success font-weight-bold font-size-30">FILTER</h3>

            <span class="font-size-18">Kategori</span>
            <vue-element-loading
              :active="isLoading"
              spinner="spinner"
              color="#28a745"
            />
            <div
              class="mt-3 mb-3"
              v-for="(item, index) in category_list"
              :key="`category_${index}`"
            >
              <label class="container"
                >{{ item.name }}
                <input type="checkbox" />
                <span class="checkmark"></span>
              </label>
            </div>
            <span class="font-size-18 font-weight-bold">Batas Harga</span>
            <br />
            <label for="">Harga Minimum</label>
            <div class="input-group mb-3">
              <br />
              <div class="input-group-prepend">
                <span
                  class="input-group-text bg-white text-success font-weight-bold"
                  id="inputGroup-sizing-default"
                  >RP</span
                >
              </div>
              <input
                type="number"
                class="form-control"
                aria-label="Default"
                aria-describedby="inputGroup-sizing-default"
              />
            </div>
            <label for="">Harga Maksimum</label>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span
                  class="input-group-text bg-white text-success font-weight-bold"
                  id="inputGroup-sizing-default"
                  >RP</span
                >
              </div>
              <input
                type="number"
                class="form-control"
                aria-label="Default"
                aria-describedby="inputGroup-sizing-default"
              />
            </div>
            <button
              class="btn w-100 show-all text-white btn-primary-theme-green font-weight-bold"
            >
              TERAPKAN HARGA
            </button>

            <button
              type="button "
              class="btn btn-outline-danger mt-4 w-100 font-weight-bold"
            >
              RESET FILTER
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-9 col-xs-12">
        <!-- Pencarian -->

        <!-- Tab -->
        <div class="tab_nav">
          <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item">
              <a
                href="javascript:void(0);"
                data-toggle="tab"
                role="tab"
                class="pl-4 pt-3 pb-3 pr-4"
                :class="tab === `semua` ? `active` : `non_active`"
                @click="tab = 'semua'"
                >SEMUA BARANG</a
              >
            </li>
            <li class="nav-item">
              <a
                href="javascript:void(0);"
                data-toggle="tab"
                role="tab"
                class="pl-4 pt-3 pb-3 pr-4"
                :class="tab === `terbaik` ? `active` : `non_active`"
                @click="tab = 'terbaik'"
                >RATING TERBAIK</a
              >
            </li>
            <li class="nav-item">
              <a
                href="javascript:void(0);"
                data-toggle="tab"
                role="tab"
                class="pl-4 pt-3 pb-3 pr-4"
                :class="tab === `terlaris` ? `active` : `non_active`"
                @click="tab = 'terlaris'"
                >PENJUALAN TERLARIS</a
              >
            </li>

            <li class="nav-item">
              <div class="row">
                <div class="col-sm-12 ">
                  <div class="select p-2">
                    <select
                      class="custom-select select_category"
                      id="inputGroupSelect01"
                    >
                      <option selected value="harga_tertinggi"
                        >Harga Tertinggi</option
                      >
                      <option value="harga_terendah">Harga Terendah</option>
                    </select>
                  </div>
                </div>
              </div>
            </li>
            <li class="nav-item"></li>
            <li class="nav-item">
              <div class="row d-flex mb-0 pl-3 pt-2 pb-2 pr-2">
                <div class="col-sm-12 text-right ml-auto">
                  <label class="mr-2 mt-2"
                    ><span class="text-success">1</span> / 100</label
                  >
                  <button class="btn btn-pagination btn-sm pr-3 mr-2">
                    <span class="ml-1"><i class="fa fa-angle-left"></i></span>
                  </button>
                  <button class="btn  btn-pagination btn-sm pl-3">
                    <span class="mr-1"><i class="fa fa-angle-right"></i></span>
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div
          class="tab-pane"
          :class="tab === `terbaik` ? `show` : `fade`"
          id="pills-home"
          v-if="tab === 'terbaik'"
          role="tabpanel"
          aria-labelledby="pills-home-tab"
        >
          <RatingTerbaik :detail_toko="detail_toko" />
        </div>
        <div
          class="tab-pane "
          :class="tab === `terlaris` ? `show` : `fade`"
          id="pills-profile"
          role="tabpanel"
          v-if="tab === 'terlaris'"
          aria-labelledby="pills-profile-tab"
        >
          <PenjualanTerlaris :detail_toko="detail_toko" />
        </div>
        <div
          class="tab-pane fade"
          id="pills-contact"
          :class="tab === `semua` ? `show` : `fade`"
          role="tabpanel"
          v-if="tab === 'semua'"
          aria-labelledby="pills-contact-tab"
        >
          <SemuaBarang :detail_toko="detail_toko" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import broker from "../../../../utils/broker";
import SemuaBarang from "../../../sections/KewirausahaanGreen/TokoPribadi/SemuaBarang";
import RatingTerbaik from "../../../sections/KewirausahaanGreen/TokoPribadi/Terbaik";
import PenjualanTerlaris from "../../../sections/KewirausahaanGreen/TokoPribadi/Terlaris";
import VueElementLoading from "vue-element-loading";

export default {
  name: "PencarianToko",
  props: {
    input_pencarian: {
      type: String,
    },
    detail_toko: {
      type: Object,
    },
  },

  components: {
    SemuaBarang,
    RatingTerbaik,
    PenjualanTerlaris,
    VueElementLoading,
  },
  data() {
    return {
      tab: "semua",
      city_filter: [
        {
          id: 1,
          name: "Jabodetabek",
        },
        {
          id: 1,
          name: "DKI Jakarta",
        },
        {
          id: 1,
          name: "Jawa Barat",
        },
        {
          id: 1,
          name: "Jawa Tengah",
        },
        {
          id: 1,
          name: "Riau",
        },
        {
          id: 1,
          name: "Banten",
        },
        {
          id: 1,
          name: "Sumatera Utara",
        },
        {
          id: 1,
          name: "DI Yogyakarta",
        },
        {
          id: 1,
          name: "Bali",
        },
        {
          id: 1,
          name: "Lampung",
        },
        {
          id: 1,
          name: "Sumatera Selatan",
        },
        {
          id: 1,
          name: "Sulawesi Selatan",
        },
        {
          id: 1,
          name: "Jambi",
        },
        {
          id: 1,
          name: "Kalimantan Timur",
        },
        {
          id: 1,
          name: "Kalimantan Selatan",
        },
        {
          id: 1,
          name: "Kalimantan Barat",
        },
        {
          id: 1,
          name: "Lainnya",
        },
      ],
      category_filter: [
        {
          name: "Fashion Pria",
        },
        {
          name: "Fashion Muslim",
        },
        {
          name: "Tas Pria",
        },
        {
          name: "Tas Wanita",
        },
        {
          name: "Sepatu Pria",
        },
        {
          name: "Sepatu Wanita",
        },
        {
          name: "Jam Tangan",
        },
        {
          name: "Elektronik",
        },
        {
          name: "Komputer & Aksesoris",
        },
        {
          name: "Handphone & Aksesoris",
        },
        {
          name: "Otomotif",
        },
        {
          name: "Aksesoris Fashion",
        },
        {
          name: "Fotografi & Kamera",
        },
        {
          name: "Hobi & Koleksi",
        },
        {
          name: "Olahraga & Outdoor",
        },
        {
          name: "Perlengkapan Rumah",
        },
        {
          name: "Buku & Alat Tulis",
        },
        {
          name: "Perlengkapan Industrial",
        },
        {
          name: "Digital Media",
        },
        {
          name: "Souvenir & Pesta",
        },
        {
          name: "Voucher",
        },
      ],
      category_list: [],
      province: [],
      isLoading: false,
      detail_merchant: {},
    };
  },
  mounted() {
    this.getDataProvince();
    this.getDataCategory();
    this.getDetailMerchant();
  },
  methods: {
    getDataProvince() {
      let self = this;
      this.isLoading = true;
      broker.fetch.get(`/webschool/enterpreneur/province`).then((res) => {
        res.data.data.forEach((item) => {
          self.province.push(item);
          this.isLoading = false;
        });
      });
    },
    getDataCategory() {
      let self = this;
      this.isLoading = true;

      broker.fetch.get(`/webschool/enterpreneur/category`).then((res) => {
        res.data.data.forEach((item) => {
          self.category_list.push(item);
          this.isLoading = false;
        });
      });
    },
    getDetailMerchant() {
      let self = this;
      this.isLoading = true;

      broker.fetch
        .get(`/webschool/enterpreneur/merchant/${this.detail_toko.id}`)
        .then((res) => {
          self.detail_merchant = res.data.data;
          this.isLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/4-sections/_kewirausahaan_detail_toko.scss";
/* The container */
</style>
